import React, { useState, useEffect } from 'react';
import { Country, State } from 'country-state-city';
import Form from 'react-bootstrap/Form';
import config from '../../config/config'
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2'; // Import SweetAlert2
import Dropzone from 'react-dropzone';
const ContactPage = () => {

  const rawParams = useParams();
  const id = rawParams.id ?? '0'; // or Number(rawParams.id ?? 0);
  const navigate = useNavigate();
    const [bannerData, setBannerData] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);;
  // const [fileName, setFileName] = useState('');
  const [fileNames, setFileNames] = useState([]);
  const [location, setLocation] = useState({ lat: null, lng: null });
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    country: '',
    state: '',
    pincode: '',
    address: '',
    query: '',
    image: [],
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    setCountries(Country.getAllCountries());
       banner();
  }, []);
let banner = async () => {
  const result = await config.getBannerByName("home");
  setBannerData(result.data || {});
};
const heroStyle = bannerData
  ? {
      backgroundImage: `url(${config.IMAGE_URL}banners/${bannerData.image})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "50vh",
    }
  : {};
  
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setLocation({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
        },
        (err) => {
          console.error("Location permission denied", err);
          // Fallback to Mumbai or any default location
          setLocation({ lat: 19.076, lng: 72.8777 });
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }, []);
  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    setFormData({ ...formData, country: countryCode, state: '' });
    setStates(State.getStatesOfCountry(countryCode));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    if (!formData.country) newErrors.country = 'Country is required';
    if (!formData.state) newErrors.state = 'State is required';
    if (!formData.pincode.trim()) newErrors.pincode = 'Pincode is required';
    if (!formData.address.trim()) newErrors.address = 'Address is required';
     if (!formData.query.trim()) newErrors.query = 'Query is required';
    if (!formData.image || formData.image.length === 0) newErrors.image = 'Image is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      Swal.fire('Validation Error', 'Please correct the highlighted fields.', 'warning');
      return;
    }

    const formPayload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formPayload.append(key, value);
    });

    // if (fileName) {
    formPayload.append("latlong", [location.lat, location.lng]);
    // }

    try {
      let response;
  formPayload.append("id", 0);
      response = await config.contactUs(formPayload); // Add


      Swal.fire({ text: response.data.message || 'Success!', icon: response.data.icon })
        .then((result) => {
          // if (result.isConfirmed) navigate(-1);
        });


      setFormData({ name: '', phone: '', email: '', country: '', state: '', pincode: '', address: '', query: '' });
      setStates([]);


    } catch (error) {
      const msg = error.response?.data?.message || 'Something went wrong!';
      Swal.fire({ text: msg, icon: 'error' }).then(() => navigate(-1));
    }
  };
  const handleFileUpload = async (acceptedFiles) => {
    if (!acceptedFiles.length) return;

    const newFileNames = [...fileNames];

    for (let file of acceptedFiles) {
      const dropZoneData = new FormData();
      dropZoneData.append('file', file);

      try {
        const res = await config.contactUsImageUpload(dropZoneData);
        newFileNames.push(res.data.filename);
      } catch (error) {
        console.error('Upload error:', error);
        Swal.fire('Error', 'Failed to upload one or more files.', 'error');
      }
    }

    setFileNames(newFileNames);
    setFormData(prev => ({
      ...prev,
      image: newFileNames,
    }));
  };


  return (
    <>

      <section>
        <div className="head">

        </div>
      </section>
      {/* Hero Section */}

      <section className="hero" style={heroStyle}>
            <div className="hero-content">
              <h1>Contact Us</h1>
              <p>Have a question or want to list your property? Fill the form and we'll get back to you shortly.</p>
            </div>
          </section>

      {/* Form */}
      <section className="form mt-2 p-5">
        <div className='row'>
          <div className="col-md-6">
            {/* <div className="card" style={{ height: "96%" }}> */}
             <div className="card" style={{ height: "96%" }}>
              <div className="card-header">
                <div className="card-title">Your Location</div>
              </div>
              <div className="card-body">
                {/* Hidden fields for location */}
                <input type="hidden" name="latitude" value={location.lat || ""} />
                <input type="hidden" name="longitude" value={location.lng || ""} />
                {location.lat && location.lng ? (
                  <iframe
                    title="Map"
                    src={`https://www.google.com/maps?q=${location.lat},${location.lng}&z=14&output=embed`}
                    width="100%"
                    height="300"
                    style={{ border: 0 ,height:600}}
                    allowFullScreen=""
                    loading="lazy"
                  ></iframe>
                ) : (
                  <p className="text-center py-5 text-muted">Fetching your location...</p>
                )}
                {/* {location.lat && location.lng ? (
          <p className="text-sm text-green-600">
            📍 Location captured: {location.lat.toFixed(4)}, {location.lng.toFixed(4)}
          </p>
        ) : (
          <p className="text-sm text-gray-500">Fetching location...</p>
        )} */}
              </div>
            </div>
          </div>

          <div className='col-md-6'>
            <div className='card'>
              <div className='card-header'>
                <div className='card-title'>Form</div>
              </div>
              <div className='card-body'>
                <Form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-xl-4 mb-3">
                      <Form.Group controlId="name">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          isInvalid={!!errors.name}
                          placeholder="Enter Name"
                        />
                        <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                    <div className="col-xl-4 mb-3">
                      <Form.Group controlId="phone">
                        <Form.Label>Phone</Form.Label>
                        <Form.Control
                          type="text"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          isInvalid={!!errors.phone}
                          placeholder="Enter Phone"
                        />
                        <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                    <div className="col-xl-4 mb-3">
                      <Form.Group controlId="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          isInvalid={!!errors.email}
                          placeholder="Enter Email"
                        />
                        <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-4 mb-3">
                      <Form.Group>
                        <Form.Label>Country</Form.Label>
                        <Form.Control
                          as="select"
                          name="country"
                          value={formData.country}
                          onChange={handleCountryChange}
                          isInvalid={!!errors.country}
                        >
                          <option value="">-- Select Country --</option>
                          {countries.map((country) => (
                            <option key={country.isoCode} value={country.isoCode}>{country.name}</option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors.country}</Form.Control.Feedback>
                      </Form.Group>
                    </div>

                    <div className="col-xl-4 mb-3">
                      <Form.Group>
                        <Form.Label>State</Form.Label>
                        <Form.Control
                          as="select"
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                          isInvalid={!!errors.state}
                          disabled={!formData.country}
                        >
                          <option value="">-- Select State --</option>
                          {states.map((state) => (
                            <option key={state.isoCode} value={state.isoCode}>{state.name}</option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors.state}</Form.Control.Feedback>
                      </Form.Group>
                    </div>

                    <div className="col-xl-4 mb-3">
                      <Form.Group controlId="pincode">
                        <Form.Label>Pincode</Form.Label>
                        <Form.Control
                          type="text"
                          name="pincode"
                          value={formData.pincode}
                          onChange={handleChange}
                          isInvalid={!!errors.pincode}
                          placeholder="Enter Pincode"
                        />
                        <Form.Control.Feedback type="invalid">{errors.pincode}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <Form.Group controlId="address">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={2}
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          isInvalid={!!errors.address}
                          placeholder="Enter Address"
                        />
                        <Form.Control.Feedback type="invalid">{errors.address}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <Form.Group controlId="query">
                        <Form.Label>Query</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={2}
                          name="query"
                          value={formData.query}
                          onChange={handleChange}
                          isInvalid={!!errors.query}
                          placeholder="Enter query"
                        />
                        <Form.Control.Feedback type="invalid">{errors.query}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <Form.Group>
                        <Form.Label>Upload File</Form.Label>

                        <Dropzone onDrop={handleFileUpload} multiple>
                          {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()} className="dropzone border p-3 rounded text-center" style={{ cursor: 'pointer' }}>
                              <input {...getInputProps()} />
                              <p>Drag & drop files here, or click to select</p>

                              <div className="d-flex flex-wrap justify-content-start mt-2 gap-2">
                                {fileNames.map((file, idx) => (
                                  <div key={idx} className="position-relative">
                                    <img
                                      src={`${config.BASE_URL}/uploads/contactUs/${file}`}
                                      alt={`preview-${idx}`}
                                      style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '4px' }}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </Dropzone>


                        {errors.image && (
                          <div className="text-danger mt-1">{errors.image}</div>
                        )}

                      </Form.Group>
                    </div>
                  </div>

                  <div className="card-action d-flex gap-2">
                    <button type="submit" className="btn btn-success">Submit</button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </button>

                  </div>
                </Form>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default ContactPage;
